// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file yatayat/auth/v1/access.proto (package yatayat.auth.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { MethodOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file yatayat/auth/v1/access.proto.
 */
export const file_yatayat_auth_v1_access: GenFile = /*@__PURE__*/
  fileDesc("Chx5YXRheWF0L2F1dGgvdjEvYWNjZXNzLnByb3RvEg95YXRheWF0LmF1dGgudjEqhgEKBkFjY2VzcxIWChJBQ0NFU1NfVU5TUEVDSUZJRUQQABIRCg1BQ0NFU1NfUFVCTElDEAESEAoMQUNDRVNTX1NUQUZGEAISEwoPQUNDRVNTX09QRVJBVE9SEAMSFAoQQUNDRVNTX1JFR1VMQVRPUhAEEhQKEEFDQ0VTU19QQVNTRU5HRVIQBTpRCgZhY2Nlc3MSHi5nb29nbGUucHJvdG9idWYuTWV0aG9kT3B0aW9ucxi5jgMgASgOMhcueWF0YXlhdC5hdXRoLnYxLkFjY2Vzc1IGYWNjZXNzQsQBChNjb20ueWF0YXlhdC5hdXRoLnYxQgtBY2Nlc3NQcm90b1ABWkJnaXRodWIuY29tL2FiZGhlc2huYXlhay95YXRheWF0L2JhY2tlbmQvZ2VuL3lhdGF5YXQvYXV0aC92MTthdXRodjGiAgNZQViqAg9ZYXRheWF0LkF1dGguVjHKAg9ZYXRheWF0XEF1dGhcVjHiAhtZYXRheWF0XEF1dGhcVjFcR1BCTWV0YWRhdGHqAhFZYXRheWF0OjpBdXRoOjpWMWIGcHJvdG8z", [file_google_protobuf_descriptor]);

/**
 * Access says who may call an RPC. The api refuses any method that does not declare one.
 * The interceptor checks the caller's kind; the domain checks which operator or
 * authority the caller may act for.
 *
 * @generated from enum yatayat.auth.v1.Access
 */
export enum Access {
  /**
   * @generated from enum value: ACCESS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Anyone, signed in or not.
   *
   * @generated from enum value: ACCESS_PUBLIC = 1;
   */
  PUBLIC = 1,

  /**
   * Any signed-in staff member: operator staff, conductor or regulator.
   *
   * @generated from enum value: ACCESS_STAFF = 2;
   */
  STAFF = 2,

  /**
   * Operator staff: operator admin, counter clerk or conductor.
   *
   * @generated from enum value: ACCESS_OPERATOR = 3;
   */
  OPERATOR = 3,

  /**
   * Regulator staff: planner, inspector or regulator admin.
   *
   * @generated from enum value: ACCESS_REGULATOR = 4;
   */
  REGULATOR = 4,

  /**
   * A passenger signed in with a phone code.
   *
   * @generated from enum value: ACCESS_PASSENGER = 5;
   */
  PASSENGER = 5,
}

/**
 * Describes the enum yatayat.auth.v1.Access.
 */
export const AccessSchema: GenEnum<Access> = /*@__PURE__*/
  enumDesc(file_yatayat_auth_v1_access, 0);

/**
 * @generated from extension: yatayat.auth.v1.Access access = 51001;
 */
export const access: GenExtension<MethodOptions, Access> = /*@__PURE__*/
  extDesc(file_yatayat_auth_v1_access, 0);

